(() => {
  const config = document.currentScript.dataset;
  const measurementId = (config.measurementId || '').trim().toUpperCase();
  if (!/^G-[A-Z0-9]+$/.test(measurementId) || window.Shopify?.designMode) return;

  const storageKey = 'ga4-order-context:v1';
  let cartCount = Number(config.cartCount);
  let cartToken = config.cartToken;
  let pending = Promise.resolve();
  let timer;
  let resumingCheckout = false;
  let checkoutPending = false;
  let lastSaved;
  try {
    lastSaved = sessionStorage.getItem(storageKey);
  } catch (_) {}

  function cookie(name) {
    const entry = document.cookie.split(';').map((value) => value.trim())
      .find((value) => value.startsWith(`${name}=`));
    if (!entry) return '';
    try {
      return decodeURIComponent(entry.slice(name.length + 1));
    } catch (_) {
      return '';
    }
  }

  function context() {
    let consent = 'unknown';
    try {
      const privacy = window.Shopify?.customerPrivacy;
      const answer = privacy?.currentVisitorConsent().analytics;
      if (answer === 'no') consent = 'denied';
      else if (privacy.analyticsProcessingAllowed()) consent = 'granted';
    } catch (_) {}
    return {
      __ga_client_id: consent === 'granted' ? cookie('_ga') : '',
      __ga_session_id: consent === 'granted' ? cookie(`_ga_${measurementId.slice(2)}`) : '',
      __ga_analytics_consent: consent,
    };
  }

  function sync(force = false) {
    pending = pending.then(async () => {
      if (!cartCount && !force) return;
      const attributes = context();
      const signature = JSON.stringify([cartToken, measurementId, attributes]);
      if (!force && signature === lastSaved) return;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 1200);
      try {
        const response = await fetch(window.theme?.routes.cart_update_url || `${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
          signal: controller.signal,
        });
        if (!response.ok) return;
        const cart = await response.json();
        cartCount = cart.item_count;
        cartToken = cart.token;
        lastSaved = JSON.stringify([cartToken, measurementId, attributes]);
        try {
          sessionStorage.setItem(storageKey, lastSaved);
        } catch (_) {}
      } catch (_) {
      } finally {
        clearTimeout(timeout);
      }
    });
    return pending;
  }

  function schedule(cart) {
    if (typeof cart?.item_count === 'number') {
      cartCount = cart.item_count;
      cartToken = cart.token || cartToken;
    } else if (cart?.items?.length) {
      cartCount = Math.max(1, cartCount);
    }
    clearTimeout(timer);
    timer = setTimeout(() => sync(), 100);
  }

  document.addEventListener('cart:updated', (event) => schedule(event.detail?.cart));
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'product-form') cartCount = Math.max(1, cartCount);
      schedule(event.cartData);
    });
  }
  document.addEventListener('visitorConsentCollected', () => schedule());
  window.addEventListener('pageshow', () => schedule());
  window.addEventListener('focus', () => schedule());
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) schedule();
  });

  function beforeCheckout(event, resume) {
    if (resumingCheckout || event.defaultPrevented) return;
    event.preventDefault();
    if (checkoutPending) return;
    checkoutPending = true;
    clearTimeout(timer);
    let timeout;
    Promise.race([
      sync(true),
      new Promise((resolve) => { timeout = setTimeout(resolve, 1500); }),
    ]).finally(() => {
      clearTimeout(timeout);
      checkoutPending = false;
      resumingCheckout = true;
      try { resume(); } finally { resumingCheckout = false; }
    });
  }

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter?.name !== 'checkout') return;
    beforeCheckout(event, () => event.target.requestSubmit(submitter));
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    beforeCheckout(event, () => { location.href = link.href; });
  });

  schedule();
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) schedule();
    });
  }
})();
